import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface ILasLamfInsert {
  id: string;
  requestedLoanAmount: string;
  mobileNo: string;
  journeyName: string;
  eventCode: string;
  tenor: string;
  roi: string;
  monthlyEmi: string;
  appId?: string;
  moduleVersion: string;
}

export interface ILasLamfInsertApiResponse {
  id: string;
}

export const lasLamfInsert = async (
  data: ILasLamfInsert
): Promise<IResponse<ILasLamfInsertApiResponse>> => {
  const response = await encryptedRequest<ILasLamfInsertApiResponse, ILasLamfInsert>({
    method: "POST",
    url: API_PATHS.lasInsert,
    data: {
      ...data,
    },
  });

  return response;
};
